import * as errorTexts from '../../const/ErrorMessages/CompanyErrorMessages';

export function validateTaxValue(tax) {
    if (tax ==="" || (!/(^[0-9]{10}$)|(^[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}$)|(^[0-9]{3}-[0-9]{2}-[0-9]{2}-[0-9]{3}$)/.test(tax))){
        throw new Error(errorTexts.INCORRECT_COMPANY_TAX_FORMAT);
    }
}

export function validateSelectedCompany(company) {
   if(company === undefined || company === null || JSON.stringify(company) === JSON.stringify({
        companyName: '',
        id: 0,
        tax: ''})
    ){
        throw new Error(errorTexts.UNSELECTED_COMPANY);
    }
}


// WEBPACK FOOTER //
// ./src/actions/Validators/CompanyValidator.js